import React, { useEffect, useState, useMemo } from "react";
import { Select, Checkbox, Input, Spin, Tooltip } from "antd";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import UIModal from "../../Reusablecomponents/UIModal";
import { useSelector } from "react-redux";
import { ReactComponent as DeleteIcon } from "../../assets/images/PrimaryDelete.svg";
import { CALL_API } from "../../Common/api";
import dayjs from "dayjs";

const { Option } = Select;

const AssignedRole = ({
  dataforroleassign,
  roleAssignId,
  getRolebyUser,
  assignedRoleLoading,
}) => {
  const getRolebyUserone = dataforroleassign?.map(function (item) {
    return {
      ASSIGNED: item.ASSIGNED,
      FULLNM: item.FULLNM,
      ROLEID: item.ROLEID,
      ROLENAME: item.ROLENAME,
    };
  });

  const roles = useSelector((state) => state?.authTracking?.roleList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const roleList = useSelector((state) => state?.authTracking?.roleList);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const deleteUserRoleAllowed = useMemo(
    () => hasPermission("ROLE", "DRFU"),
    [reduxPermissions],
  );
  const assignRoleAllowed = useMemo(
    () => hasPermission("ROLE", "ARTU"),
    [reduxPermissions],
  );
  useEffect(() => {
    setSelectedRoles(dataforroleassign?.map((role) => role?.ROLEID));
  }, [dataforroleassign]);

  const deleteRoleAction = async (id) => {
    try {
      const { data } = await CALL_API("DELETE", "role/deleteAssignRole", {
        UID: roleAssignId,
        ROLEID: id,
      });
      getRolebyUser();
      setIsModalOpen(false);
    } catch (error) {
      console.error("[fetchAllRoleAction] error:", error);
    } finally {
    }
  };

  const fetchAllRoleAction = async (id) => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "role/assign_role", {
        UserId: roleAssignId,
        UserRole: selectedRoles
          ?.filter((item) => item !== id)
          ?.map((role) => ({ RoleID: role })),
        AddedBy: userInfo?.UID,
      });
      getRolebyUser();
      setIsModalOpen(false);
    } catch (error) {
      console.error("[fetchAllRoleAction] error:", error);
    } finally {
      setLoading(false);
    }
  };

  const RoleAssignmentColumns = [
    {
      title: "Role",
      dataIndex: "ROLENAME",
      key: "rolename",
    },
    {
      title: "Assigned By",
      render: (_, record) => (
        <>
          {record.FULLNM} <br />
          {record.ASSIGNED
            ? dayjs(record.ASSIGNED).format("DD/MM/YYYY hh:mm A")
            : "-"}
        </>
      ),
      key: "assignedby",
    },
    {
      title: "Action",
      key: "icon",
      render: (_, record) =>
        (
          <DeleteIcon
            style={{
              cursor: deleteUserRoleAllowed ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (!deleteUserRoleAllowed) return;
              deleteRoleAction(record?.ROLEID);
            }}
          />
        ) || "",
    },
  ];
  // Handle selection
  const handleChange = (values) => {
    if (values.includes("all")) {
      setSelectedRoles(roles?.map((role) => role?.ROLEID));
    } else {
      setSelectedRoles(values);
    }
  };

  // Filter roles based on search
  const filteredRoles = roles.filter((role) =>
    role?.ROLENAME.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <p className="p-0 m-0">Assign Role to:</p>
        <Tooltip title={!assignRoleAllowed ? "No permission" : ""}>
          <ButtonFilled
            style={{ padding: "0px 20px" }}
            onClick={() => setIsModalOpen(true)}
            loading={loading}
            disabled={!roleAssignId || !assignRoleAllowed}
          >
            + Assign Role
          </ButtonFilled>
        </Tooltip>
      </div>
      <Spin spinning={assignedRoleLoading}>
        <StyledTable
          className="mt-0"
          dataSource={dataforroleassign}
          columns={RoleAssignmentColumns}
          pagination={false}
          style={{
            cursor: "default",
          }}
        />
      </Spin>

      <UIModal
        header="Assign Role"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent onClick={() => setIsModalOpen(false)}>
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              onClick={() => fetchAllRoleAction()}
            >
              Assign Role
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="p-3">
          <Select
            mode="multiple"
            value={selectedRoles}
            onChange={handleChange}
            placeholder="Select"
            style={{ width: "100%" }}
            maxTagCount="responsive"
            dropdownRender={(menu) => (
              <>
                <div style={{ padding: "5px" }}>
                  <Checkbox
                    checked={selectedRoles?.length === roles.length}
                    onChange={(e) =>
                      handleChange(e.target.checked ? ["all"] : [])
                    }
                  >
                    Select All
                  </Checkbox>
                </div>
                <div style={{ padding: "5px" }}>
                  <Input
                    placeholder="Search"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                {menu}
              </>
            )}
          >
            {filteredRoles.map((role) => (
              <Option key={role?.ROLEID} value={role?.ROLEID}>
                <Checkbox checked={selectedRoles?.includes(role?.ROLEID)}>
                  {role?.ROLENAME}
                </Checkbox>
              </Option>
            ))}
          </Select>
        </div>
      </UIModal>
    </>
  );
};

export default AssignedRole;
